export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.48.0-de48ae84e.svg#trust-pilot-star","viewBox":"0 0 96 96"}